// 定义filters
// src/filters.ts
import dayjs from "dayjs";

const filters = {
  formatDate(value: any, format = "YYYY-MM-DD HH:mm:ss") {
    return dayjs(value).format(format);
  },
  //格式化分数
  formatScore(value: any) {
    if (value == "999") {
      return "合格";
    } else if (value == "1000") {
      return "不合格";
    } else {
      return value + "分";
    }
  },
  //格式化数字，整数保留整数，小数保留两位小数
  formatNumber(value: any) {
    if (value == "-") {
      return "-";
    } else {
      return value.toFixed(2).replace(/\.00$/, "");
    }
  },
};

export default filters;
